"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgBuilding = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M4 4a2 2 0 012-2h12a2 2 0 012 2v17a1 1 0 01-1 1h-4a1 1 0 01-1-1v-6h-4v6a1 1 0 01-1 1H5a1 1 0 01-1-1V4zm15 6v3h-2v-3h2zm-4 0h-2v3h2v-3zm-6 0h2v3H9v-3zm-2 0H5v3h2v-3zm12-5v3h-2V5h2zm-4 0h-2v3h2V5zM9 5h2v3H9V5zM7 5H5v3h2V5z' }))); };
exports.default = SvgBuilding;
//# sourceMappingURL=Building.js.map